import { Box, Grid, Link, Typography, useMediaQuery, useTheme } from '@mui/material'

import React from 'react'
import { useNavigate } from 'react-router'

// import { Link } from 'react-router-dom'

const Footer = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const phone = useMediaQuery(theme.breakpoints.between(280,830))
  const Titles = ({title,onClick}) =>{
    return(
      <Link sx={{borderBottom:"1px solid #D9D9D9" ,p:"2px",cursor:'pointer',textDecorationLine:"none"}} href={onClick} target='_blank' onClick={()=>{
        window.scrollTo(0, 0);
  
        }}   >
        <p style={{color:'#fff',fontSize:phone ? '16px':'13px'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100"> {title}</p>
      </Link>
    )
  }
  return (
    <Box component={"footer"} width={"100%"} position={"static"} bgcolor={"#424242"}>
 
        <Grid container display={"flex"} flexDirection={phone?"column":"row"}  alignItems={"center"}  justifyContent={"space-around"} p="10px">
          <Grid component={"div"} 
          item lg={2} xl={2} md={2} sm={12} xs={12} display={"flex"} flexDirection="column"  alignItems={"center"} gap={6}>
            <Box display={"flex"} flexDirection="column" alignItems={"center"} gap={1}>
              <img src="/images/logo.png" alt="jansnak" width="82px"     />
              <h5 style={{color:'#fff'}}>زندگی خوشمزه</h5>
              <p style={{color:'#fff',fontSize:'12px'}}> اولین برند زنجیره ای اسنک در ایران </p>
              <h5 style={{color:'#fff'}} > Delicious life </h5>
            </Box>

            <Box display={"flex"} flexDirection="column" alignItems={"center"} gap={1}>
              <Link href='tel:1507'  width={"80%"}>
                <img src="/images/tel.png" alt="1507" style={{padding:"10px",width:'100%'}}    />

              </Link>
              <Box display={"flex"}   data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="5000" justifyContent={"center"} position={"relative"} gap={1} width={"100px"}  alignItems={"center"} mr="7%">
                <Link  borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.aparat.com/jan_snak" >
                  <img src="/images/aparat.png" alt="" width="15px" height={"15px"} />
                </Link>
                <Link  borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://t.me/jansnakbot" >
                  <img src="/images/telegram.png" alt="" width="15px" height={"15px"} />
                </Link>
                <Link  borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://instagram.com/jan_snak" >
                  <img src="/images/facebook.png" alt="" width="15px" height={"15px"} />
                </Link>
                <Link borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://instagram.com/jan_snak" >
                  <img src="/images/instagram.png" alt=""width="15px" height={"15px"} />
                </Link>
                          {/* <Box   mr="60%" border="1px solid #000" borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"}> */}
                <Link   borderRadius={"50%"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.linkedin.com/company/jansnak">
                  <img src="/images/linkedin.png" alt="" width="15px" height={"15px"}/>
                </Link>

              </Box>
            </Box>
          </Grid>
          <Grid component={"div"} item lg={10} xl={10} md={10} sm={12} xs={12} display={"flex"} flexDirection={phone?"column":"row"} justifyContent={"space-between"}  gap={2} p="10px" >

            <Box component={"div"} display={"flex"} flexDirection={"column"} gap={2} >
              <Box>
                <img src="/images/aboutjan.png" alt=""  />
              </Box>
                <Titles title={"لیست شعب"} onClick={"/home/branches"} />
                <Titles title={"شعب در شرف افتتاح "} onClick={"/home/newbranch"} />
                <Titles title={" تیم مدیریتی "} />
                <Titles title={" چارت سازمانی "} />
      
                <Titles title={" ضوابط خرید"} onClick={`/home/new/${17}`} />
                <Titles title={" درباره ما "} onClick={`/home/new/${16}` } />
                <Titles title={"ارزش های ما"} />
                <Titles title={" سهامداران جان اسنک "} />
                <Titles title={" اطلاعات فرانچایز کارخانجات ما "} />
                <Titles title={" حریم خصوصی "} onClick={`/home/new/${18}` } />
            </Box>

            <Box component={"div"} display={"flex"} flexDirection={"column"} gap={2}>
              <Box>
                <img src="/images/Cooperation.png" alt="" />
              </Box>
                <Titles onClick={'/home/news'} title={" مجله خبری جان"} />
                <Titles title={" دوره های آموزشی "} />
                <Titles title={" مزایای استخدام "} />
                <Titles title={" مدیریت منابع انسانی "} />
                <Titles title={"فرصت های شغلی "} onClick={" https://jobs.jansnak.com/"} />
                <Titles title={" گواهینامه های آموزشی "} />
                <Titles title={"  استخدام در جان اسنک"} onClick={ "https://jobs.jansnak.com/"} />

            </Box>
            <Box component={"div"} display={"flex"} flexDirection={"column"} gap={2} >
              <Box>
                <img src="/images/info.png" alt="" />
              </Box>
                <Titles title={"بروشور الکترونیک"} onClick={`https://jansnak.com/dl/Jansnak_Digital_catalog.pdf`} />
                <Titles title={" مرکز تماس 1507 "} />
                <Titles title={" تخفیف های مناسبتی مشتری "} />
                <Titles title={" واگذاری شعبه "} onClick={ "https://superapp.jansnak.com/franchizing"} />
                <Titles title={"جان پلاس"} />
                <Titles title={" دانشنامه جان اسنک "} />
                <Titles title={" جان دلیوری "} />
                <Titles title={" تجهیز و تامین"} />
                <Titles title={" سامانه تامین کنندگان " } />

            </Box>
            <Box component={"div"} display={"flex"} flexDirection={"column"} gap={2} >
              <Box>
                <img src="/images/manage.png" alt="" />
              </Box>
                <Titles title={" ارسال پیام مستقیم به مدیریت "} onClick={`/home/contact/${-2}`} />
                <Titles title={" ارتباط با واحد های ستادی "} onClick={`/home/contact/${-3}`} />
                <Titles title={" ارتباط با شعب جان "} onClick={'/home/branches'}  />
                <Titles title={" اینستاگرام جان اسنک "}  onClick={"https://instagram.com/jan_snak"} />
                <Titles title={" بات تلگرام جان اسنک"} onClick={"https://t.me/jansnakbot"} />
                <Titles title={" آپارات جان اسنک"} onClick={"https://www.aparat.com/jan_snak"} />
                <Titles title={" فیسبوک جان اسنک"}  />
                <Titles title={" لینکدین جان اسنک"} onClick={"https://www.linkedin.com/company/jansnak" } />


            </Box>

            <Box component={"div"} display={"flex"} flexDirection={"column"} gap={2}  >
              <Box>
                <img src="/images/charity.png" alt="" />
              </Box>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100" >خط مشی مسئولیت اجتماعی جان</p>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="200" > حمایت از زندانیان نیازمند </p>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="300" > مرکز مستند نگاری جان اسنک </p>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="400" > صندوق نیکوکاری  </p>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="500">  حمایت از مادران و کودکان  </p>
              <p style={{cursor:'pointer',color:'#fff',border:"1px solid #F39D40",padding:'7px 15px',borderRadius:'15px'}}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="600">  استخدام شرایط خاص </p>
              <Box>
                {/* <img src="/images/sign.png" alt=""     /> */}
              </Box>
            </Box>
          </Grid>
        </Grid>

      <Box display={"flex"} flexDirection={"column"} gap={1} alignItems={"center"} p="20px" borderTop={"1px solid #fff"}marginTop={"20px"}>
        <strong style={{color:"#fff",textAlign:'center'}}> معاونت فناوری اطلاعات و شبکه ارتباطات </strong>
        <strong style={{color:"#fff",textAlign:'center'}}>  شرکت رستوران های زنجیره ای زندگی خوشمزه ایرانیان (جان اسنک) </strong>
        <p style={{color:"#fff",textAlign:'center'}}> کلیه حقوق این سایت متعلق به برند زنجیره ای جان اسنک می باشد و هرگونه کپی برداری از محتوا و عکس ها بدون ذکر منبع پیگرد قانونی دارد</p>
      </Box>
    </Box>
  )
}

export default Footer